
    import { Component, Vue } from 'vue-facing-decorator';
    @Component
    export default class NotFound extends Vue {
    }
